import { autoMount } from '../../../utils/autoMount';
import { Tvs } from '../../../components/pages/tvs';

autoMount({ Tvs });
